var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23637_2153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23637_2153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.95002 20.3C6.63335 19.6167 6.39585 18.9167 6.23752 18.2C6.07918 17.4833 6.00002 16.75 6.00002 16C6.00002 14.6167 6.26252 13.3167 6.78752 12.1C7.31252 10.8833 8.02502 9.825 8.92502 8.925C9.82502 8.025 10.8833 7.3125 12.1 6.7875C13.3167 6.2625 14.6167 6 16 6C17.3833 6 18.6833 6.2625 19.9 6.7875C21.1167 7.3125 22.175 8.025 23.075 8.925C23.975 9.825 24.6875 10.8833 25.2125 12.1C25.7375 13.3167 26 14.6167 26 16C26 17.3833 25.7375 18.6833 25.2125 19.9C24.6875 21.1167 23.975 22.175 23.075 23.075C22.175 23.975 21.1167 24.6875 19.9 25.2125C18.6833 25.7375 17.3833 26 16 26C15.25 26 14.5167 25.9208 13.8 25.7625C13.0833 25.6042 12.3833 25.3667 11.7 25.05L6.75002 26.5C6.36668 26.6167 6.03335 26.5333 5.75002 26.25C5.46668 25.9667 5.38335 25.6333 5.50002 25.25L6.95002 20.3ZM7.95002 24.05L11.15 23.1C11.3833 23.0333 11.6208 23.0083 11.8625 23.025C12.1042 23.0417 12.3333 23.1 12.55 23.2C13.0833 23.4667 13.6417 23.6667 14.225 23.8C14.8083 23.9333 15.4 24 16 24C18.2333 24 20.125 23.225 21.675 21.675C23.225 20.125 24 18.2333 24 16C24 13.7667 23.225 11.875 21.675 10.325C20.125 8.775 18.2333 8 16 8C13.7667 8 11.875 8.775 10.325 10.325C8.77502 11.875 8.00002 13.7667 8.00002 16C8.00002 16.6 8.06668 17.1917 8.20002 17.775C8.33335 18.3583 8.53335 18.9167 8.80002 19.45C8.91668 19.6667 8.97918 19.8958 8.98752 20.1375C8.99585 20.3792 8.96668 20.6167 8.90002 20.85L7.95002 24.05Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5195 12.4346V16.0346L19.5195 19.0346C19.7029 19.2179 19.7945 19.4512 19.7945 19.7346C19.7945 20.0179 19.7029 20.2512 19.5195 20.4346C19.3362 20.6179 19.1029 20.7096 18.8195 20.7096C18.5362 20.7096 18.3029 20.6179 18.1195 20.4346L14.8195 17.1346C14.7195 17.0346 14.6445 16.9221 14.5945 16.7971C14.5445 16.6721 14.5195 16.5429 14.5195 16.4096V12.4346C14.5195 12.1512 14.6154 11.9137 14.807 11.7221C14.9987 11.5304 15.2362 11.4346 15.5195 11.4346C15.8029 11.4346 16.0404 11.5304 16.232 11.7221C16.4237 11.9137 16.5195 12.1512 16.5195 12.4346Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatHistory);
export default __webpack_public_path__ + "static/media/chat-history.f4b6c7ecb7b1ea455265ab0aa3eba68e.svg";
export { ForwardRef as ReactComponent };